export default {
  paid: "PAID",
  toCancel: "TO_CANCEL",
};
